"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var vue_property_decorator_1 = require("vue-property-decorator");
require("vuetify/dist/vuetify.min.css");
var PicklistsEdit_1 = __importDefault(require("@app/components/picklist/PicklistsEdit"));
var picklist_1 = __importDefault(require("@app/types/picklist"));
var SchwammService_1 = __importDefault(require("../service/SchwammService"));
var SchwammPicklistsEdit = /** @class */ (function (_super) {
    __extends(SchwammPicklistsEdit, _super);
    function SchwammPicklistsEdit() {
        var _this = _super.call(this) || this;
        /* @ts-ignore */
        _this.service = SchwammService_1.default;
        return _this;
    }
    SchwammPicklistsEdit.prototype.isMobile = function () {
    };
    SchwammPicklistsEdit.prototype.created = function () {
        this.progressMessage = this.$t('page.picklist.edit.please_wait');
    };
    SchwammPicklistsEdit.prototype.scrollTop = function () {
        window.scroll(0, window.pageYOffset - 50);
    };
    /**
     * Load Picklist from order_number
     */
    SchwammPicklistsEdit.prototype.loadOrder = function () {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_b) {
                this.progressDialog = true;
                /* @ts-ignore */
                (_a = this.service) === null || _a === void 0 ? void 0 : _a.getByOrderNumber(this.orderNumber).then(function (response) {
                    var _a, _b, _c, _d, _e;
                    if (response instanceof picklist_1.default) {
                        _this.picklist = response;
                        if (((_b = (_a = _this.picklist.orders) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.ordered_at) instanceof Date) {
                            _this.picklist.orders[0].ordered_at = (_e = (_d = (_c = _this.picklist.orders) === null || _c === void 0 ? void 0 : _c[0]) === null || _d === void 0 ? void 0 : _d.ordered_at) === null || _e === void 0 ? void 0 : _e.toISOString();
                        }
                        _this.alerts = [];
                        _this.picklistStep = 2;
                    }
                    else {
                        if (response.status > 400) {
                            _this.alerts.push({ text: "Für diese Bestellung wurden bereits alle Items Gepickt!", type: 'error' });
                            var container = document.getElementById('v-app');
                            container.scrollTop = 0; // not working
                        }
                    }
                    _this.progressDialog = false;
                }).catch(function (response) {
                    _this.alerts.push({ text: "Für diese Bestellung wurden bereits alle Items Gepickt!", type: 'error' });
                    var container = document.getElementById('v-app');
                    container.scrollTop = 0; // not working
                }).finally(function () {
                    _this.progressDialog = false;
                });
                return [2 /*return*/];
            });
        });
    };
    SchwammPicklistsEdit.prototype.pickItem = function () {
        var _this = this;
        var _a;
        //this.progressMessage = this.$t('page.picklist.edit.please_wait')
        this.progressDialog = true;
        this.alerts = [];
        /* @ts-ignore */
        (_a = this.service) === null || _a === void 0 ? void 0 : _a.pickItem(this.orderNumber, this.scanCode).then(function (response) {
            var _a, _b;
            var data = (_a = response.data) === null || _a === void 0 ? void 0 : _a.data;
            (_b = _this.picklist) === null || _b === void 0 ? void 0 : _b.items.forEach(function (picklistItem) {
                if (picklistItem.id == (data === null || data === void 0 ? void 0 : data.id)) {
                    /* @ts-ignore */
                    if (picklistItem.quantity > picklistItem.qty_picked) {
                        picklistItem.qty_picked += 1;
                        if (picklistItem.picked_data == undefined) {
                            picklistItem.picked_data = [];
                        }
                        picklistItem.picked_data.push({ weight: data.picked_weight, mhd: data.picked_mhd });
                    }
                    else {
                        _this.alerts.push({
                            text: "Dieser Artikel wurde bereits " + picklistItem.quantity + " mal gepickt!",
                            type: 'error'
                        });
                        var container = document.getElementById('v-app');
                        container.scrollTop = 0; // not working
                    }
                }
            });
            _this.checkFinished();
        }).catch(function (error) {
            _this.alerts.push({ text: error.response.data[0], type: 'error' });
            _this.$vuetify.goTo(0);
        }).finally(function () {
            window.scrollTo(0, 0);
            _this.progressDialog = false;
            _this.scanCode = "";
        });
        //this.progressMessage = this.$t('page.picklist.edit.please_wait')
    };
    SchwammPicklistsEdit.prototype.checkFinished = function () {
        var _this = this;
        var _a, _b;
        var finished = true;
        (_a = this.picklist) === null || _a === void 0 ? void 0 : _a.items.forEach(function (item) {
            if (item.qty_picked != item.quantity) {
                finished = false;
                return;
            }
        });
        if (finished) {
            /* @ts-ignore */
            (_b = this.service) === null || _b === void 0 ? void 0 : _b.finishPicking(this.orderNumber, this.picklist).then(function (response) {
                _this.clearInputs();
                _this.picklistStep = 1;
            });
        }
    };
    SchwammPicklistsEdit.prototype.formatDate = function (date) {
        if (typeof (date) == "string") {
            var date1 = date.substr(0, 10);
            var _a = date1.split('-'), year = _a[0], month = _a[1], day = _a[2];
            return day.padStart(2, '0') + "." + month.padStart(2, '0') + "." + year;
        }
        return "";
    };
    SchwammPicklistsEdit.prototype.clearInputs = function () {
        this.picklist = null;
        this.scanCode = "";
        this.orderNumber = "";
        this.alerts = [];
    };
    SchwammPicklistsEdit.prototype.formatOrderedAtDate = function () {
        var _a, _b, _c;
        this.formattedOrderedAt = this.formatDate((_c = (_b = (_a = this.picklist) === null || _a === void 0 ? void 0 : _a.orders) === null || _b === void 0 ? void 0 : _b[0]) === null || _c === void 0 ? void 0 : _c.ordered_at);
    };
    __decorate([
        vue_property_decorator_1.Watch("picklist.order.ordered_at", { deep: true }),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], SchwammPicklistsEdit.prototype, "formatOrderedAtDate", null);
    SchwammPicklistsEdit = __decorate([
        vue_property_decorator_1.Component({
            name: 'SchwammPicklistsEdit'
        }),
        __metadata("design:paramtypes", [])
    ], SchwammPicklistsEdit);
    return SchwammPicklistsEdit;
}(PicklistsEdit_1.default));
exports.default = SchwammPicklistsEdit;
